import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { v4 as uuidv4 } from 'uuid';

import Bs4Dialog from '../Bs4Components/Bs4Dialog';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportGeneric from './Bs4ReportGeneric';
import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4I18N from '../Bs4I18N';

import { getBoxSx, useStateUxTemplate, SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';

const TYPE_BS4REPORTTYPE49 = 'type_Bs4ReportType49';

//Kafle
export default class Bs4ReportType49 extends Bs4ReportGeneric {

  /////////////////// form field /////////////////////////////
  getValue() {
    return null;
  }

  resetOriginalValue() {
  }  

  isDifferentValues (oldValue, newVaue) {
    return false;
  }

  clear() {
  }
  //////////////////////////////////////////////////////////
  
  static SORT_DIR_ASC = 'ASC';
  static SORT_DIR_DESC = 'DESC';

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportType49',
    body: {        
      Report49: {
        panel: {
          backgroundColor: "rgba(255, 255, 255, 1)",
          margin: 1,
          padding: 1,
          elevation: 2,
          borderRadius: 1,
        },         
      },        
    },
  };

  getUxTemplateEditor = (uxEditor) => {

    return [{
      label: Bs4I18N.getTT('Report49', 'Report49', 'Bs4ReportType49'),
      onReset: () => this.uxTemplate.body.Report49.panel = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report49.panel)),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4REPORTTYPE49],
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report49;
        const type = TYPE_BS4REPORTTYPE49;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='borderColor' title='Ramka'/>
            </Stack>                                  
            
            <uxEditor.ViewCssShadow types={type} value={uxBody.panel} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='widthMargin' title='width'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='padding'/>
          </Box>
        );
      },
    }]
  }

  sorters = {field: null, dir: null};

  reload = () => {
    //console.log('....Type49 Reload...')
    this.fetchMore()
  }

  getColumns() {
    const column = this.getColDef();
    // for (const column of this.getColDef()) {
    //   console.log('... Type 49 ... COLUMN', column)
    // }

    return column;
  }

  getColumnWidth() {
    for (const column of this.getColDef() || []) {
      return parseInt(column.width) || 200;
    }
  }

  fetchCriteriaVals() {
		const filterCriteria = this.defaultCriteriaVals();    				
		if (this.remembersettings) filterCriteria.remembersettings = 1;
		filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
		return filterCriteria;
	}

  packColumnLayout() {
    const tablica = this.getColDef().map((column, index) => {
      return {
        dataIndex: column.dataIndex,
        hidden: false,
        id: column.dataIndex, 
        index: index + 1,
      }
    })
    
    return JSON.stringify(tablica);
  }

  fetchMore() {
    const baseValues = this.fetchCriteriaVals(); //this.defaultCriteriaVals();    
    baseValues.page = parseInt(this.bs4PageProps.currentPage) || 0;
    baseValues.start = baseValues.page * this.bs4PageProps.paglim;
    if (this.sorters.field) {
      baseValues.sort = this.sorters.field;
      baseValues.dir = this.sorters.dir;
    }

    const newBaseValues = Bs4MainDispatch.getParserParams(baseValues, this.bs4KartotekaId);
    const formData = new FormData();
    for (let [key, value] of Object.entries(baseValues)) formData.append(key, value);
    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        Bs4MainDispatch.speedRun((tag) => {      
          console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId));
        }, '..Type49..More.');
        const returnedJson = JSON.parse(returnedText);
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
        const data = returnedJson.dane.map(record => {
          record.id = record.id || uuidv4();          
          return record;
        })
                
        if (this.setData) {
          this.setData(data);
          this.setBs4PageProps({
            ...this.bs4PageProps,
            currentPage: baseValues.page, 
            lastRow: returnedJson.ilosc, 
            lastPage: Math.ceil(returnedJson.ilosc / this.bs4PageProps.paglim),
            inProgress: false,
          });
        }
      } catch (error) {
        console.log(returnedText);
        console.log(error);
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  bs4HandleChangePage(page) {
    this.bs4PageProps.currentPage = page - 1;
    this.fetchMore();
  }    

  ViewColumns = (props) => {
    const report = this;
    const [open, setOpen] = React.useState(false);
    const [columns, setColumns] = React.useState(this.getColumns().filter(column => column.sortable));
    const [sorter, setSorter] = React.useState({field: null, dir: null});
    const refHeader = React.useRef(null);

    const handleOpen = () => {
      //setColumns(this.getColumns().filter(column => column.sortable));
      setSorter(this.sorters);
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleClick = (e, column) => {
      column.toggle();
      setColumns([...columns]);
    }

    const handleChangeSurtAsc = (e, column) => {
      this.sorters = {field: column.dataIndex, dir: Bs4ReportType49.SORT_DIR_ASC};
      setSorter(this.sorters);
      this.reload();
    }        

    const handleChangeSurtDes = (e, column) => {
      this.sorters = {field: column.dataIndex, dir: Bs4ReportType49.SORT_DIR_DESC};
      setSorter(this.sorters);
      this.reload();
    }     
    
    const handleEditColumn = (e, column) => {
      const details = {
        targetObject: column.dataIndex.replace('zx', ''),
        targetOption: 468,
        currCardViewId:report.bs4KartotekaId,
        currOptionId:report.optionId,
        currFormId: this.formId,
      }
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, report.bs4KartotekaId);
    }

    const handleGear = (event) => {
      console.log('...handleGear...', )      
      Bs4MainDispatch.commandParser('Bs4OpenCard', {targetObject: this.optionId, targetOption: 2000149}, this.bs4KartotekaId);
    }

    if (!columns || columns.length === 0) return null;

    const icon = "fa-solid fa-layer-group";
    return (
      <React.Fragment>
        <IconButton onClick={handleOpen}><i className={icon}></i></IconButton>
        {columns ?
        <Bs4Dialog
          refHeader={refHeader}  
          open={open}
          onClose={handleClose}          
          bs4KartotekaId={report.bs4KartotekaId}
          hideBackdrop={true}
        >
          <DialogTitle ref={refHeader} sx={{touchAction: 'none'}}>
            <Stack width='100%' direction='row' justifyContent="space-between" sx={{cursor:'move'}}>
              <span><i className="fa-solid fa-layer-group"/>&nbsp;&nbsp;{"Kolumny"}</span>
              {report.props.bs4ConstructorMode.enabled ?
                <IconButton edge='end' onClick={handleGear}><i className="fa-solid fa-gear"/></IconButton>
              : null}
            </Stack>
          </DialogTitle>
          <DialogContent>          
            <List sx={{bgcolor: 'background.paper'}}> 
              {/* maxWidth: '90%' */}
              {columns.map((column, index) => {
                const title = column.text;
                const sortVisibility = column.sortable ? 'visible' : 'hidden';
                return (
                  <ListItem key={index} disablePadding>
                    <ListItemButton onClick={(e) => handleClick(e, column)} dense>                      
                      <ListItemText primary={title}/>
                    </ListItemButton>
                    <ListItemIcon sx={{display: report.props.bs4ConstructorMode.enabled ? 'block' : 'none'}}>
                      <IconButton onClick={(event) => handleEditColumn(event, column)}>
                        <i className='fa-solid fa-gear' title='Edit'></i>
                      </IconButton>
                    </ListItemIcon>
                    <ListItemIcon>                    
                      <Checkbox
                        sx={{visibility: sortVisibility}}
                        //edge="start"
                        checkedIcon={<i className="fa-solid fa-arrow-down-short-wide"></i>} 
                        icon={<i className="fa-thin fa-arrow-down-short-wide"></i>}
                        checked={column.dataIndex === sorter.field && sorter.dir === Bs4ReportType49.SORT_DIR_ASC}
                        onChange={(e) => handleChangeSurtAsc(e, column)}
                      />
                    </ListItemIcon>
                    <ListItemIcon>
                      <Checkbox
                        sx={{visibility: sortVisibility}}
                        //edge="start"
                        checkedIcon={<i className="fa-solid fa-arrow-up-wide-short"></i>} 
                        icon={<i className="fa-thin fa-arrow-up-wide-short"></i>}
                        checked={column.dataIndex === sorter.field && sorter.dir === Bs4ReportType49.SORT_DIR_DESC}
                        onChange={(e) => handleChangeSurtDes(e, column)}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>         
          </DialogContent>
          <DialogActions>            
            <Button onClick={handleClose}>{'Ok'}</Button>
          </DialogActions>
        </Bs4Dialog>
        : null
        }
      </React.Fragment>
    )
  }

  isEqualId = (id, row) => {    
    if (row?.id && String(row.id) === String(id)) return true;
    return false
  }

  ViewPanel = (props) => {  
    const report = this;
    const theme = useTheme()
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE49);
    const ref = React.useRef(null)

    const boxSx = React.useMemo(() => {
      return {        
        ...getBoxSx(this.uxTemplate?.body?.Report49?.panel, theme),        
        ...getBoxSx(props.row.xx555, theme),        
        overflow: 'hidden',
      }      
    }, [dateTimeStamp, theme, props.row.xx555]);   

    const handleClick = (event) => {
      console.log('...row.click.', event, props.row, );
      Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId);
      // if(this.getPageParam('row_active_click')) {
      //   Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: row.getData().id }, this.bs4KartotekaId);
      // }	
      if(this.getPageParam('row_active_click')) {
        console.log('..row click.2.', event, props.row, )
        Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: props.row.id, currFormId: this.formId }, this.bs4KartotekaId);
      }	
    }

    //let width = `calc(${props.bs4LayoutEditorProps.width}% - ${theme.spacing(2 * props.bs4LayoutEditorProps.margin)})`;    
    
    //console.log('...kafel..xxx555.', props.row, sss, report.uxTemplate)     

    React.useEffect(() => {
      const trigger = props.trigger;
      if (trigger && this.isEqualId(trigger.id, props.row)) {
        // console.log('...Type49..trigger..useEff.1.', props)
        const close = (showObject) => {
          // console.log('...Type49...close', props);
          trigger.showObject = showObject;
          trigger.setTrigger(null);
        }
  
        trigger?.trigger(ref, close);
      }
  
      return () => {
        if (trigger && this.isEqualId(trigger?.id, props.row)) {
          if (trigger.showObject) trigger.showObject();
        }
      }
    }, [props.trigger, props.row, ref.current])

    return (
      <Box 
        ref={ref}
        sx={boxSx}
        dangerouslySetInnerHTML={{__html: Bs4MainDispatch.updateUrlText(props.row.kk330)}} 
        onClick={handleClick}
        onMouseDown={(e) => false}
      />
    )
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const [data, setData] = React.useState([])  
    const [trigger, setTrigger] = React.useState(null);
    const smallScreen = React.useContext(SmallScreenContext);

    React.useEffect(() => {      
      this.setData = (newData) => {
        setData(newData)
      }

      this.fetchMore();
    }, [setData])

    React.useEffect(() => {      
      this.showTooltip = (id, trigger) => {
        setTrigger({
          id, 
          trigger,
          setTrigger,
          setObject: null,
        });        
      }
    }, [data])

    return (
      <Box ref={ref} height='100%' width='100%' display='flex' flexDirection="column" overflow='hidden' px={props.uxKartoteka?.spacing}>
        <Box display="flex" flexDirection="row" flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
          <Bs4Criteria {...report.props}/>
          <report.ViewColumns/>
          <report.ReportBs4HorizontalMenu/>
        </Box>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>
        <Box flex={1} overflow='auto'>
          <Box display='flex' flexDirection='row' flexWrap='wrap' overflow={'hidden'} gap={0}>
            {data.map(row => (
              <report.ViewPanel key={row.id} row={row} trigger={trigger}/>
            ))}
          </Box>
        </Box>
        <report.ViewBs4Footer smallScreen={smallScreen}/>
      </Box>
    )
  });
}